<template>
  <div class="col-md-6 col-sm-6 col-xs-6 q-pl-sm">
    <section class="row align">
      <div class="row col-12 justify-between items-center">
        <span class="text-h6 text-brand-5">Lista Usuarios</span>
        <q-checkbox
          v-model="ferramentaAssosiada"
          label="Somente usuários já com ferramenta"
          true-value="1"
        />
      </div>
      <div class="row col-12 justify-between">
        <div>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="filter"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search"></q-icon>
            </template>
          </q-input>
        </div>
        <div>
          <q-btn
            class="respI"
            no-caps
            color="positive"
            icon="check_circle_outline"
            label="Selecionar Todos"
            @click="selecionarTodos"
          />
          <q-btn
            class="respI q-ml-md"
            no-caps
            color="red"
            icon="highlight_off"
            label="Desselecionar Todos"
            @click="desselecionarTodos"
          />
        </div>
      </div>
    </section>
    <q-table
      flat
      table-header-class="bg-accent text-width-bold"
      class="q-mt-sm tabela-tamanho-fixo"
      style="height: 500px"
      :rows="listaUsuarios"
      dense
      :columns="columns"
      :loading="disable"
      :rows-per-page-options="[0]"
      hide-pagination
      hide-bottom
      no-data-label
      @request="handleRequest"
    >
      <template #body-cell-selecione="props">
        <q-td>
          <q-checkbox v-model="selecionados" :val="props.row" />
        </q-td>
      </template>
      <template #body-cell-vinculados="props">
        <q-td>
          <q-btn
            class="q-ml-lg"
            round
            size="sm"
            color="primary"
            icon="visibility"
            @click="getFerramentasVinculadas(props.row.id)"
          />
        </q-td>
      </template>
    </q-table>
    <div class="row justify-start q-mt-md">
      <q-pagination
        :disable="disable"
        v-model="pagination.page"
        color="brand-5"
        active-color="secondary"
        active-text-color="white"
        :max="pagesNumber"
        :max-pages="5"
        :boundary-numbers="false"
        :direction-links="true"
        size="sm"
      />
    </div>
  </div>
</template>

<script>
import { ref, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  props: ["atualizar"],
  setup(props, { emit }) {
    const store = useStore();
    const router = useRouter();
    const unidade = ref({
      id: "",
      nome: "",
    });
    const filter = ref("");
    const disable = ref(true);
    const selecionados = ref([]);
    const listaUnidades = ref([]);
    const listaUsuarios = ref([]);
    const selecionaImagem = ref(false);
    const ferramentaAssosiada = ref(false);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 100,
      rowsNumber: 100,
    });

    const columns = [
      {
        name: "selecione",
        label: "Usuário",
        field: "Selecionar",
        align: "left",
      },
      {
        name: "name",
        label: "Usuário",
        field: (row) => row.name,
        align: "left",
      },
      {
        name: "email",
        label: "Email",
        field: "email",
        align: "left",
      },
      {
        name: "vinculados",
        label: "Verificar Associações",
        field: "vinculados",
        align: "left",
      },
    ];

    let listarUsuarios = async (page = 0, rowsPerPage = 10) => {
      if (props.atualizar == "" || props.atualizar == undefined) {
        listaUsuarios.value = [];
        return;
      }
      disable.value = true;
      try {
        let resposta = await store.dispatch("fer/listarUsuarios2", {
          vendor_id: store.state.org.unidadeData.id,
          perPage: rowsPerPage,
          page: page,
          search: filter.value,
          vinculado_ferramenta: ferramentaAssosiada.value,
        });

        listaUsuarios.value = resposta.data.results.data;
        pagination.value.rowsPerPage = resposta.data.results.per_page;
        pagination.value.rowsNumber = resposta.data.results.total;
        pagination.value.page = resposta.data.results.current_page;

        disable.value = false;
      } catch (error) {
        console.error(error);
      }
    };

    const selecionarTodos = async () => {
      listaUsuarios.value.forEach((e) => {
        selecionados.value.push(e);
      });
      emit("usuariosSelecionados", selecionados.value);
    };

    const desselecionarTodos = async () => {
      selecionados.value = [];
    };

    watch(
      () => selecionados.value,
      () => {
        emit("usuariosSelecionados", selecionados.value);
      }
    );

    watch(
      () => filter.value,
      () => {
        listarUsuarios();
      }
    );

    watch(
      () => ferramentaAssosiada.value,
      () => {
        listarUsuarios();
      }
    );

    watch(
      () => props.atualizar,
      () => {
        listarUsuarios();
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        listarUsuarios();
      }
    );

    const handleRequest = async () => {
      listarUsuarios(pagination.value.page, pagination.value.rowsPerPage);
    };

    watch(
      () => pagination.value.page,
      () => {
        handleRequest();
      }
    );

    const detalhes = async (value) => {
      router.push({
        name: "movimentarStatusFerramentaDetalhes",
        params: { id: value },
      });
    };

    const getFerramentasVinculadas = async (value) => {
      let resposta = await store.dispatch("fer/getUsuarioFerramentaVinculo", {
        user_id: value,
      });

      emit("vinculados", resposta.data.result);
      emit("userDesvincularId", value);
    };

    return {
      unidade,
      selecionaImagem,
      listaUsuarios,
      listaUnidades,
      columns,
      selecionados,
      disable,
      filter,
      selecionarTodos,
      desselecionarTodos,
      handleRequest,
      pagination,
      ferramentaAssosiada,
      getFerramentasVinculadas,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      detalhes,
    };
  },
};
</script>
